import {Form} from 'react-bootstrap';
import React from 'react';
import {CommonFile} from './api';
import {UseMutationResult} from 'react-query';

interface ToggleCommonDocumentVisibilityProps {
    file: CommonFile;
    toggleHandler: (file: CommonFile) => UseMutationResult<CommonFile | null, unknown, void>;
}

const ToggleCommonDocumentVisibility = ({
    file,
    toggleHandler,
}: ToggleCommonDocumentVisibilityProps): JSX.Element => {
    const {mutate} = toggleHandler(file);
    return (
        <>
            <Form.Switch
                onChange={() => {
                    mutate();
                }}
                checked={file.visible}
            />
        </>
    );
};

export default ToggleCommonDocumentVisibility;
